export default __webpack_public_path__ + "static/media/ic_star_blue_outlined.733ccfaa.svg";